import { useCreateLinkToFinancialDocument } from "@mutations/transaction";
import { EagerLoaded } from "@common/types/base/orm";
import { Transaction } from "@common/types/transaction";
import { FinancialDocument } from "@common/types/financialDocument";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";

interface Props {
    financialTransaction: EagerLoaded<Transaction, "transactionMatches">;
    financialDocument: FinancialDocument;
}

export const TransactionMatchingAttachCta: React.FC<Props> = ({
    financialTransaction,
    financialDocument,
}) => {
    const alreadyMatched = financialTransaction.transactionMatches.some(
        (tm) => tm.financialDocument?.id === financialDocument.id,
    );

    const createLink = useCreateLinkToFinancialDocument(
        financialTransaction,
        financialDocument,
    );

    return (
        <ButtonWithLoader
            variant="primary"
            size="sm"
            onClick={() => {
                createLink.mutate();
            }}
            disabled={alreadyMatched}
            loading={createLink.isPending}
        >
            {alreadyMatched ? "Attached" : "Attach"}
        </ButtonWithLoader>
    );
};
